import { render, staticRenderFns } from "./PageContentSectionsContainerMenu.vue?vue&type=template&id=dd4b49ea&scoped=true"
import script from "./PageContentSectionsContainerMenu.vue?vue&type=script&lang=js"
export * from "./PageContentSectionsContainerMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4b49ea",
  null
  
)

export default component.exports